module.exports = __webpack_public_path__ + "img/portal-main.696fd9f0.jpg";